<template>
    <div class="create_order" style="background: #fff;">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>

        <div class="join_over width_center_1200">
            <div class="join_bzt">
                <el-steps :active="2" finish-status="process" simple >
                    <el-step title="我的购物车" icon="el-icon-shopping-cart-full"></el-step>
                    <el-step title="物流地址" icon="el-icon-map-location"></el-step>
                    <el-step title="选择支付" icon="el-icon-mouse"></el-step>
                    <el-step title="支付成功" icon="el-icon-check"></el-step>
                </el-steps>
            </div>
        </div>


        <div class="order_chose width_center_1200">

            <el-collapse accordion v-model="activeNames">
                <!-- 收货地址 -->
                <el-collapse-item name="1">
                    <template slot="title">
                    <div class="order_chose_title">
                        收货地址:<span v-if="defaultAddress" class="default">{{defaultAddress.address}} / {{defaultAddress.contact}} / {{defaultAddress.phone}}</span>
                        <el-button type="success" size="mini" @click="setAddress">设置</el-button>
                    </div>
                    </template>
                    <div class="address_chose" v-if="payState == 0">
                        <div class="address_list ">
                            <ul>
                                <li :class="v.status==3?'red':''" v-for="(v,k) in address_list.slice(0, 4)" :key="k">
                                    <div class="receive_name">{{v.contact}} <span>({{v.phone}})</span></div>
                                    <div class="area_info">{{v.address}}</div>
                                    <div :class="v.status==3?'is_default_red':'is_default'"><i class="icon iconfont">&#xe611;</i></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </el-collapse-item>

                <!-- 配送方式 -->
                <el-collapse-item name="2" v-show="express != 3">
                    <template slot="title">
                        <div class="order_chose_title">配送方式:
                            <span v-if="express == 0" class="default" >公司配送</span>
                            <span v-if="express == 1" class="default">自提</span>
                            <span v-if="express == 2 && buygroup" class="default" >包邮</span>
                        </div>
                    </template>
                    <div v-if="payState == 0">
                        <el-radio-group v-model="express" @change="selectExpress(express)">
                            <el-radio-button label="0">公司配送</el-radio-button>
                            <el-radio-button label="1">自提</el-radio-button>
                            <el-radio-button label="2" v-if="buygroup">包邮</el-radio-button>
                        </el-radio-group> 
                    </div>
                </el-collapse-item>

                <!-- 订单备注 -->
                <el-collapse-item name="3">
                    <template slot="title">
                        <div class="order_chose_title">订单备注:
                            <span v-if="remark" class="default">已备注</span>
                            <span v-else class="default">无</span>
                        </div>
                    </template>
                    <div class="el-table el-table--border">
                        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                            <tbody>
                                <tr class="el-table__row"><td><div class="cell"><el-input style="padding: 20px;" v-model="remark" show-word-limit type="textarea"></el-input></div></td></tr>
                                <tr class="el-table__row" v-if="payState == 0"><td><div class="cell"><el-button type="primary" size="small" @click="selectRemark(remark)">确定</el-button></div></td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-collapse-item>

                <!-- 订单商品信息 -->
                <el-collapse-item  name="4">
                    <template slot="title">
                    <div class="order_chose_title">订单商品信息:<span class="default">{{list.length}}</span></div>
                    </template>

                    <el-table ref="orderListTable"
                                class="table"
                                :data="list"
                                stripe
                                height="416"
                                style="width: 100%;"
                                v-loading="listLoading" border>
                        <el-table-column label="商品ID" align="center" width="100" sortable prop="goodsId" fixed="left">
                            <template slot-scope="scope">
                                <p>{{scope.row.goodsId}}</p>
                                <p>
                                    <el-tag size="mini" type="danger" v-if="scope.row.discountId == 3">秒杀</el-tag>
                                    <el-tag size="mini" type="success" v-if="scope.row.discountId == 2">特价</el-tag>
                                    <el-tag size="mini" type="danger" v-if="scope.row.discountId == 9">专享</el-tag>
                                    <el-tag size="mini" type="success" v-if="scope.row.discountId == 14">满赠</el-tag>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="商品图片" align="center" width="120" sortable prop="spuName">
                            <template slot-scope="scope">
                                <el-popover placement="top-start" trigger="click" v-if="scope.row.img">
                                    <img :src="filePath + scope.row.img" style="max-width: 600px;height: auto">
                                    <img slot="reference" :src="filePath + scope.row.img" style="width: 50px;height: auto; cursor: pointer;">
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column label="商品信息" align="left" sortable prop="loginId" min-width="300px">
                            <template slot-scope="scope">
                                <p v-if="scope.row.comboId" style="margin-bottom: 5px;" @click="handleViewsGoods(scope.$index, scope.row)">{{scope.row.spuName}} <el-tag size="mini" effect="dark">套餐商品</el-tag></p>
                                <p v-else>{{scope.row.spuName}}</p>
                                <p @click="handleViewsGoods(scope.$index, scope.row)"><el-tag type="success">批号:{{scope.row.batchno}}</el-tag>&nbsp;&nbsp;<el-tag>规格:{{scope.row.spec}}</el-tag>&nbsp;&nbsp;<el-tag type="info">{{scope.row.companyName}}</el-tag></p>
                            </template>
                        </el-table-column>
                        <el-table-column label="现价" width="100" align="center" sortable prop="price">
                            <template slot-scope="scope">
                                <span v-if="scope.row.promoPrice">￥{{scope.row.promoPrice}}</span>
                                <span v-else>￥{{scope.row.oriPrice}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="到手价" width="100" align="center" sortable prop="price">
                            <template slot-scope="scope">￥{{scope.row.price}}</template>
                        </el-table-column>
                        <el-table-column label="数量" width="100" align="center" sortable prop="orderQty">
                            <template slot-scope="scope">{{scope.row.orderQty}}</template>
                        </el-table-column>
                
                    </el-table>
                
                </el-collapse-item>
            </el-collapse>

            <div style="width: 100%; clear: both;"></div>

            <!-- 订单金额与优惠信息 -->
            <div class="order-summary">
                <div class="statistic fr mt20">
                    <div class="list">
                        <span><em class="ftx-01">{{list.length}}</em> 件商品，总商品金额：</span>
                        <em class="price">￥{{total_price}}</em>
                    </div>

                    <div class="list">
                        <span>运费：</span>
                        <em class="price"><font color="#FF6600"> {{postage>0?'+￥'+postage:'免运费'}}</font></em>
                    </div>

                    <div class="list"  v-show="groupBuy" v-if="orderInfo.couponMoney > 0">
                        <span>优惠券：</span><em class="price" id="couponPriceId" style="display: block;">-￥{{orderInfo.couponMoney}}</em>
                    </div>


                    <!-- <div class="list" v-if="orderInfo.virtualMoney > 0">
                        <span>欣币：</span><em class="price" id="couponPriceId" style="display: block;">-￥{{orderInfo.virtualMoney}}</em>
                    </div> -->

                    <div class="list" v-if="orderInfo.order && orderInfo.order.surcharge">
                        <span>附加费：</span><em class="price" id="couponPriceId" style="display: block;">￥{{orderInfo.order.surcharge}}</em>
                    </div>

                    <div v-if="activityid > 0 && payState == 0">
                        <div class="list" >
                            <span>可用余额：</span><em class="price" id="couponPriceId" style="display: block;">￥{{activityid}}</em>
                        </div>
                        <el-form :model="balance"
                            ref="discountForm"
                            :rules="rules"
                            label-width="120px" size="small">
                            <el-form-item label="使用余额：">
                                <el-input-number v-model="balance.usemoney" size="medium" :min="0" :max="activityid" style="text-align: right;" @change="handleChange" :precision="2" :step="1" controls-position="right" v-loading="loading5"></el-input-number>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="clr"></div>
            </div>

            <div class="trade-foot-detail-com">
                <div class="fc-price-info">
                    <span class="price-tit">应付总额：</span>
                    <span class="price-num" v-if="balance.usemoney != undefined && balance.usemoney != null && balance.usemoney !=''">￥{{NowPrice=(total_money - balance.usemoney).toFixed(2)}}</span>
                    <span class="price-num" v-else>￥{{NowPrice=(total_money).toFixed(2)}}</span>
                </div>
                <div class="fc-consignee-info">
                    <span class="mr20">寄送至：{{address.province}}  {{address.city}}  {{address.county}}  {{address.address}} </span>
                    <span class="mr20">收货人：{{address.contact}}  </span><span>手机：{{address.phone}}</span>
                </div>
            </div>

            <!-- 付款倒计时 -->
            <span v-if="payState == 0 && startTime == true" style="padding:20px 0; float:right"><p style="text-align:right;">付款倒计时</p>
                <div class="time">{{hour}}<span>时</span></div>
                <div class="time">{{min}}<span>分</span></div>
                <div class="time">{{secs}}<span>秒</span></div>
            </span>

            <div class="order_chose_title" v-if="payState == 0">
                选择支付方式
            </div>

            <!-- 支付方式 -->
            <div class="pay_list" v-if="payState == 0">
                <ul>
                    <li @click="scanCode()" v-preventRepeat="3000" v-loading="loading0" v-if="total_money - balance.usemoney > 0"><el-image src="/pc/pay2.jpg"></el-image></li>
                    <li v-if="activityid >= total_money" @click="balancePayment()" v-loading="loading3"><img src="/pc/pay1.jpg"></li>
                    <li @click="toshow()" v-loading="loading4" v-if="total_money - balance.usemoney > 0"><img src="/pc/pay3.jpg"></li>
                    <div class="money_pay"></div>
                </ul>
            </div>


            <div class="pay_list">
                <ul>
                    <div class="money_pay"></div>
                </ul>
            
            </div>

        </div>

        <!-- 公司账户 -->
        <el-dialog title="公司账户" :visible.sync="BankAccountList" :before-close="handleCloseBankAccountList" :close-on-click-modal="false" width="40%">

            <!-- <div class="table-layout">
                <el-row>
                    <el-col :span="5" class="table-cell-title">银行</el-col>
                    <el-col :span="19" class="table-cell">{{bankInfo.bankName}}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="table-cell-title">户名</el-col>
                    <el-col :span="19" class="table-cell">{{bankInfo.username}}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="table-cell-title">账号</el-col>
                    <el-col :span="19" class="table-cell">{{bankInfo.bankNo}}</el-col>
                </el-row>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="BankAccountList = false" size="small">取 消</el-button>
                <el-button type="danger" @click="set_default()" size="small">确定转账</el-button>
            </span> -->

            <div class="table-layout">
                <el-row>
                    <el-col :span="5" class="table-cell-title">银行</el-col>
                    <el-col :span="19" class="table-cell">四川省科欣医药贸易有限公司</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="table-cell-title">户名</el-col>
                    <el-col :span="19" class="table-cell">中国民生银行成都分行聚龙路支行</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="table-cell-title">账号</el-col>
                    <el-col :span="19" class="table-cell">691638647</el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="BankAccountList = false" size="small">取 消</el-button>
                <el-button type="danger" @click="set_default()" size="small">确定转账</el-button>
            </span>

        </el-dialog>

        <!-- 二维码扫描 -->
        <el-dialog title="扫码支付" :visible.sync="dialogVisible" :before-close="handleClose" :close-on-click-modal="false" width="20%">
            <div class="scan_qr">
                <p>扫码后请稍等，不要关闭支付窗口!</p>
                <vue-qr :logoSrc="imageUrl" :text="qr_code" :size="200"></vue-qr>
                <p>订单金额:&nbsp;&nbsp;<span style="color: red; font-weight: bold;">{{odrMoney}}</span>&nbsp;&nbsp;元</p>
            </div>
        </el-dialog>

        <!-- 线下汇款 -->
        <el-dialog :visible.sync="remittanceVisible" width="40%" :close-on-click-modal="false" :show-close="false" title="转账汇款">
            <el-row>
                <div class="el-dialog-div">
                    <div class="table-container">
                        <el-form :model="bank"
                            :rules="rules"
                            ref="bankFrom"
                            label-width="150px">
                            <el-form-item label="选择账户：" prop="BankAccount">
                                <el-select v-model="bank.BankAccount" filterable @change="handleSellTypeChange" placeholder="请选择银行账户">
                                <el-option
                                    v-for="item in querySellType"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="remittanceVisible = false;money_pay=false;">取 消</el-button>
                <el-button type="primary" @click="submitPayPwd()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 编辑(添加)账户 -->
        <el-dialog :title="isEdit?'编辑账户':'添加账户'" :visible.sync="dialogVisibleBankAccount" width="30%">
            <el-form  label-width="150px" ref="info" :model="info" size="small">
                <el-form-item label="户名" prop="name" :rules="[{required:true,message:'户名不能为空',trigger: 'blur' }]"><el-input placeholder="请输入户名" v-model="info.name"></el-input></el-form-item>
                <el-form-item label="账号" prop="account" :rules="[{required:true,message:'账号不能为空',trigger: 'blur' }]"><el-input placeholder="请输入账号" v-model="info.account"></el-input></el-form-item>
                <el-form-item label="银行" prop="bankId" :rules="[{required:true,message:'开户行不能为空',trigger: 'blur' }]"><el-input placeholder="请输入开户行" v-model="info.bankId"></el-input></el-form-item>
                <el-form-item label="是否默认">
                    <el-radio-group v-model="info.isDefault" size="mini">
                    <el-radio-button label="true" >是</el-radio-button>
                    <el-radio-button label="false">否</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleBankAccount = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitForm('info')" size="small">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 转账凭证 -->
        <el-dialog title="转账凭证" 
            :visible.sync="change_transferShow"
            :show-close="false"
            :close-on-click-modal="false"
            width="30%">

            <div class="freight_info">
                <div class="table-layout">
                    <el-row>
                        <el-col :span="5" class="table-cell-title">订单号</el-col>
                        <el-col :span="19" class="table-cell">{{orderId}}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5" class="table-cell-title">凭证号</el-col>
                        <el-col :span="19" class="table-cell">{{payLogId}}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5" class="table-cell-title">转账金额</el-col>
                        <el-col :span="19" class="table-cell color-mony">{{(total_money - balance.usemoney).toFixed(2)}}</el-col>
                    </el-row>
                    
                    <el-row>
                        <el-col :span="5" class="table-cell-title">开户行</el-col>
                        <el-col :span="19" class="table-cell">四川省科欣医药贸易有限公司</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5" class="table-cell-title">户名</el-col>
                        <el-col :span="19" class="table-cell">中国民生银行成都分行聚龙路支行</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5" class="table-cell-title">账号</el-col>
                        <el-col :span="19" class="table-cell">691638647</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5" class="table-cell-title" style="height:200px;">转账凭证</el-col>
                        <el-col :span="19" class="table-cell"  style="height:200px;">
                            <el-upload style="width:180px; margin:10px auto; height:auto;" class="avatar-uploader" :action="$api.uploadUserAvatar+'payImg'" :headers="upload_headers" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                                <img v-if="payImg" :src="payImg" class="avatar-upload">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel_transferShow" size="small">取消</el-button>
                <el-button type="primary" @click="paymentVoucher" size="small">确定</el-button>
            </span>
        </el-dialog>

        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
      
        <ShopMbar></ShopMbar>
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
import {formatDate} from '@/utils/date';
import {validatePrice} from '@/utils/validate';
import vueQr from 'vue-qr'
    const defaultInfo = {
    name:null,
    account:null,
    bankId:'',
    isDefault:true,
    status:3,
  };
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
		vueQr
    },
    inject:['reload'],
    props: {},
    data() {
      return {
          list:[],
          banklist:[],
          couponlist:[],
          address_list:[],//收货地址
          express:0,      //配送方式
          remark:'',      // 备注
          activeNames: ['4'], //折叠面板
          defaultAddress:null, //默认收货地址
          total_price:0.00,
          total_freight:0,
          total_money:0.00,
          gainpromId:null,
          dialogVisible:false,
          dialogVisibleunionpayMoney:false,
          remittanceVisible:false,
          info: Object.assign({}, defaultInfo),
          dialogVisibleBankAccount:false,
          BankAccountList:false,
          qr_code:'',
          timeObj:null,
          timer:null, //二维码定时器名称
          money_pay:false, // 余额支付
          pwdVisible:false, // 支付密码输入
          pay_password:'',
          listLoading: false,
          bank:{
              BankAccount:'',
          },
          balance:{
              activityid:0.00,
              usemoney:0.00,
          },
          userInfo:[],
          address:{},
          order:{},
          active: 1,
          isSelect:1,
          NowPrice:0.00,
          error:0,
          coupon_money:0.00,
          minfee:null,
          filePath:null,
          hour:0,
          min:0,
          secs:0,
          intvalobj:null,
          fontSkill:'结束',
          payWay:true,
          payState:null,
          postage:0,
          activityid: 0.00,
          payImg:null,
          payLogId:null,
          upload_headers:{},
          change_transferShow:false,
          startTime:true,
          loading:false,
          loading0:false,
          loading1:false,
          loading2:false,
          loading3:false,
          loading4:false,
          loading5:false,
          groupBuy:true,
          nowUserId:null,
          activeName: 'first',
          discountMoney:0,
          discountMrror:0,
          showGainprom:false,
          showCoupon:true,
          isShowGainprom:false,
          isShowCoupon:true,
          companyName:null,
          bankInfo:{
            bankName:null
          },
          isShowLine:true,
          orderInfo:[],   //订单明细
          payInfo:[],
      // 表单校验
          rules: {
            usemoney: [
                    {required:true,message:'请输入余额',trigger: 'blur' },
                    {required: true, trigger: 'change', validator: validatePrice}
            ],
            }
      };
    },
    filters:{
      formatCreateTime(time) {
        let date = new Date(time);
        if(time===undefined||time===null||time===''){
          return '暂无';
        }else{
          return formatDate(date, 'MM月dd日');
        }
      },
      formatText(value) {
        if(value===undefined||value===null||value===''){
          return 0.00;
        }
        return value.toFixed(2);
      },
    },

    watch: {
    },
    computed: {

    },
    methods: {  
        //设置收货地址 
        setAddress(event){
            event.stopPropagation();
            this.$router.push('/user/address'); 
        },
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
                localStorage.setItem('filePath',res.data[0].config);
            });
        },


        handleChange (value) {
            this.loading5 = true;
            if(value == undefined){
                this.loading5 = false;
                this.balance.usemoney = '0.00';
            }else if(value > this.activityid){
                if(this.total_money > this.activityid){
                    this.loading5 = false;
                    this.$nextTick(function () {
                        setTimeout(()=>{
                            this.balance.usemoney = this.activityid;
                        },300)
                    });
                }else{
                    this.loading5 = false;
                    this.$nextTick(function () {
                        setTimeout(()=>{
                            this.balance.usemoney = this.total_money;
                        },300)
                    });
                }
            }else if(value <= this.activityid){
                  if(value >= this.total_money){
                    this.loading5 = false;
                    this.$nextTick(function () {
                        setTimeout(()=>{
                            this.balance.usemoney = this.total_money;
                        },300)
                    });
                }else{
                    this.loading5 = false;
                    this.$nextTick(function () {
                        setTimeout(()=>{
                            this.balance.usemoney = value;
                        },300)
                    });
                    // this.$message.success('不能超过订单金额')
                }
            }
        },


        // 根据购物车的数据或者商品的数据来获取订单的数据
        get_order_list:function(){
            // this.$post(this.$api.homeGetBeforOrder,{type:this.$route.params.type,info:this.$route.params.info}).then(res=>{
            this.$get(this.$api.GetOrderInfoByOrderNo+this.$route.params.info,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.getCompanyAccountByCompanyId();
                    this.getPayMentList();
                    this.list = res.data.orderDetailParamList;
                    if(res.data.addressList){
                        this.address = res.data.addressList[0];
                    }
                    this.total_price = res.data.order.total;
                    this.total_money = res.data.order.money;
                    this.orderInfo = res.data;
                    this.postage = res.data.order.postage;
                    this.end_time = res.data.order.orderTime;
                    this.payState = res.data.order.payState;
                    this.remark = res.data.order.remark;
                    this.express = res.data.express;
                    this.addressId = res.data.order.addressId;
                    this.termValidity = res.data.order.termValidity;
                    if(res.data.order.payState == 0){
                        this.start_time();
                        this.payWay = true;
                    }else{
                        this.$router.push('/user/order_info?id='+this.$route.params.info); 
                    }
                    if(this.balance.usemoney == undefined){
                        this.balance.usemoney = 0
                    }
                }else if(res.code == 401){
                    this.$message.error(res.message);
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');        //用户信息
                    localStorage.removeItem('goodsCategory');   //栏目分类
                    localStorage.removeItem('column_list');     //底部菜单
                    localStorage.removeItem('popup_num');       //弹窗广告
                    localStorage.removeItem('serviceInfo');     //清除专属客服专属业务员
                    localStorage.removeItem('token');           //清除token
                    localStorage.removeItem('discount_rate');   //清除折扣率
                    return this.$router.push('/user/login');
                }else{
                    this.$message.error(res.message);
                    return this.$router.push('/');
                }

            });
        },


        // 根据购物车的数据或者商品的数据来获取订单的数据
        get_list:function(){
            // this.$post(this.$api.homeGetBeforOrder,{type:this.$route.params.type,info:this.$route.params.info}).then(res=>{
            this.$get(this.$api.GetOrderInfoByOrderNo+this.$route.params.info,{platId:this.$platId}).then(res=>{
                this.list = res.data.orderDetailParamList;
                this.total_price = res.data.order.total;
                this.total_money = res.data.order.money;
                this.postage = res.data.order.postage;
                this.remark = res.data.order.remark;
                this.express = res.data.express;
                this.addressId = res.data.order.addressId

            });
        },

        //倒计时1小时未付款取消订单
        start_time:function(){
            if(this.intvalobj != null){
                clearInterval(this.intvalobj);
            }

            this.intvalobj = setInterval(()=>{
                let end_time = Math.floor(new Date(this.end_time).getTime() / 1000);
                let endTime = end_time + 3600*this.termValidity;
                let timestamp = Date.parse(new Date())/1000;
                if(endTime > timestamp){
                    let sec2 = endTime-timestamp;
                    this.hour = Math.floor(sec2/3600);
                    this.min = Math.floor((sec2-(this.hour*3600))/60);
                    this.secs = sec2-(this.hour*60+this.min)*60;
                    this.fontSkill = '结束';
                }else{
                    this.hour = 0;
                    this.min = 0;
                    this.secs = 0;
                    this.fontSkill = '付款超时，请重新下单！';
                    this.$router.push('/user/order/'); 
                    this.payWay = false,
                    clearInterval(this.intvalobj);
                }
            },1000);
        },



        //当前用户优惠券列表
        getCouponsToOrdersList:function(){
            // console.log(this.total_price);
            this.$get(this.$api.getCouponsToOrders+(this.total_price),{platId:this.$platId}).then(res=>{
                this.couponlist = res.data;
                if(this.couponlist.length){
                    this.isSelect = 1;
                }else{
                    this.isSelect = 2;
                    this.showGainprom = true,
                    this.showCoupon = false,
                    this.isShowCoupon = false,
                    this.isShowLine = false,
                    this.getCalcVirtualMoney();
                }
                this.minfee = res.data.minfee;
            });
        },    

        //银行账户列表
        BankAccount_list:function(){
            this.$get(this.$api.getBankAccount,{platId:this.$platId}).then(res=>{
                this.banklist = res.data;
                this.banklist.companyId = res.data.companyId;
            });
        },

        //获取用户余额
        getCompanyAccountByCompanyId:function(){
            this.Authorization = localStorage.getItem('token'); 
            this.$get(this.$api.getCompanyAccountByCompanyId+-1,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    if(res.data != null){
                        this.balance = res.data;
                        this.activityid = res.data.money;
                        //计算可用余额  默认使用余额
                        // this.balance.usemoney = res.data.money;
                        if(res.data.money > 0){
                            if(this.total_money >= this.balance.usemoney){
                                this.balance.usemoney = this.balance.usemoney;
                            }else{
                                this.balance.usemoney = this.total_money;
                            }
                        }else{
                                this.balance.usemoney = 0
                        }
                    }else{
                        this.balance.usemoney = 0;
                    }
                }

            });
        },


        //获取虚拟币
        getCalcVirtualMoney:function(info){
            this.$get(this.$api.calcVirtualMoney+this.$route.params.info,{
                platId:this.$platId,
                userId:this.nowUserId,
                // orderId:this.$route.params.info,
                }).then(res=>{
                if(res.code == 200){
                    if(res.data.discountMoney != null){
                        this.isShowGainprom = true;
                        this.discountMoney = res.data.discountMoney;
                        this.discountMrror = res.data.error;
                    }else{
                        this.discountMoney = '0';
                        this.discountMrror = '0'
                    }
                }

            });
        },

        // 计算运费
        get_order_info:function(){
            this.$post(this.$api.homeGetOrderInfoByOrderNo,{order_no:this.$route.params.orderId}).then(res=>{
                res.data.forEach(orderRes=>{
                    this.total_freight += orderRes.freight_money;
                });
            });
        },

        // 微信扫码支付
        pc_wxpay:function(){
            this.BankAccountList = false;
            if(this.NowPrice > 0){
            this.$post(this.$api.homePayWxOrder,{
                orderid:this.$route.params.info,
                gid:this.gainpromId,
                balance:this.balance.usemoney,
                platId:this.$platId,
                discountMoney:this.discountMoney,
                type:2
                }).then(res=>{
                if(res.code==200){
                    if(res.data==null){
                    this.$message.success('已支付成功,即将进入订单页!');
                    this.$router.push('/user/order/'); 
                    }else{
                    this.qr_code = res.data.imageQRCode;
                    this.odrMoney = res.data.odrMoney;
                    this.billNo = res.data.billNo;
                    this.dialogVisible = true;
                    this.timeObj = setInterval(()=>{
                        this.check_pay(this.$route.params.info);
                    },5000);
                    }

                }else{
                    this.dialogVisible = true;
                    this.$message.error('调起支付失败');
                }
            });
            }else{
                this.$message.error('付款金额不能小于0');
            }
        },

        // 支付宝扫码支付
        pc_alipaypay:function(){
            this.BankAccountList = false;
            this.$post(this.$api.homePayOrder,{
                orderId:this.$route.params.info,
                gainpromoId:this.gainpromId,
                balance:this.balance.usemoney,
                platId:this.$platId,
                discountMoney:this.discountMoney,
                busiCode:'2002'
            }).then(res=>{
                if(res.code == 200){
                    if(res.data == null){
                        this.$message.success('已支付成功,即将进入订单页!');
                        this.$router.push('/user/order/'); 
                    }else{
                        this.qr_code = res.data.imageQRCode;
                        this.odrMoney = res.data.odrMoney;
                        this.billNo = res.data.billNo;
                        this.dialogVisible = true;
                        this.timeObj = setInterval(()=>{
                            this.check_pay(this.$route.params.info);
                        },5000);
                    }

                }else{
                    this.dialogVisible = true;
                    this.$message.error(res.message);
                }
            });
        },

        //扫码聚合支付
        scanCode1:function(){
            if((this.total_money - this.balance.usemoney).toFixed(2) <= 0){
               return this.$message.error('支付金额为0，请使用余额支付!');
            }
            this.loading0 = true;
            setTimeout(()=>{
                this.BankAccountList = false;
                this.$post(this.$api.homePayOrder,{
                    orderId:this.$route.params.info,
                    gainpromoId:0,
                    balance:this.balance.usemoney,
                    platId:this.$platId,
                    discountMoney:0,
                    type:'PC'
                }).then(res=>{
                    if(res.code == 200){
                        this.loading0 = false;
                        if(res.data == null){
                            this.$message.success('已支付成功,即将进入订单页!');
                            this.$router.push('/user/order/'); 
                        }else{
                            this.qr_code = res.data.payUrl;
                            this.odrMoney = res.data.money;
                            // this.billNo = res.data.billNo;
                            this.dialogVisible = true;
                            this.timeObj = setInterval(()=>{
                                this.check_pay(this.$route.params.info);
                            },3000);
                        }
                    }else{
                        this.loading0 = false;
                        this.dialogVisible = false;
                        this.$message.error(res.message);
                        clearInterval(this.timeObj);
                    }
                });
            },800)
        },

        // 扫码支付
        scanCode:function(){
            if(this.loading1 === true) {
                return;
            }
            this.loading1 = true;
            this.BankAccountList = false;
            this.$post(this.$api.homePayOrder,{"rows":[{id:this.$route.params.info,gainpromoId:this.gainpromId,balance:this.balance.usemoney}]}).then(res=>{
                if(res.code==200){
                    this.loading1 = false;
                    if(res.data==null){
                    this.$message.success('已支付成功,即将进入订单页!');
                    this.$router.push('/user/order/'); 
                    }else{
                    this.qr_code = res.data.imageQRCode;
                    this.odrMoney = res.data.odrMoney;
                    this.billNo = res.data.billNo;
                    this.dialogVisible = true;
                    this.timeObj = setInterval(()=>{
                        this.check_pay(this.$route.params.info);
                    },5000);
                    }

                }else{
                    this.loading1 = false;
                    this.dialogVisible = true;
                    this.$message.error('调起支付失败');
                }
            });
        },

        handleClose() {
            this.dialogVisible = false;
            clearInterval(this.timeObj);
        },

        handleCloseBankAccountList(){
            this.BankAccountList = false;
        },
        //银联支付
        unionpayMoney:function(){
            this.BankAccountList = false;
            this.$post(this.$api.homePayOrder,{
                orderId:this.$route.params.info,
                gainpromoId:this.gainpromId,
                balance:this.balance.usemoney,
                platId:this.$platId,
                busiCode:'3003',
                discountMoney:this.discountMoney
            }).then(res=>{
                if(res.code == 200){
                    if(res.data == null){
                        this.$message.success('已支付成功,即将进入订单页!');
                        clearInterval(this.timeObj);
                        this.$router.push('/user/order/'); 
                    }else{
                        this.qr_code = res.data.imageQRCode;
                        this.odrMoney = res.data.odrMoney;
                        this.billNo = res.data.billNo;
                        this.dialogVisible = true;
                        this.timeObj = setInterval(()=>{
                            this.check_pay(this.$route.params.info);
                        },5000);
                    }

                }else{
                    this.dialogVisible = true;
                    this.$message.error(res.message);
                }
            });

        },
        
        // 定时查询是否支付成功
        check_pay:function(){
            this.$post(this.$api.chinaumsNotify + this.$route.params.info).then(res=>{
                if(res.code == 200){
                    clearInterval(this.timeObj);
                    clearInterval(this.intvalobj);
                    this.$router.push('/user/order/');
                }else if(this.dialogVisible== false){
                    // clearInterval(this.timeObj);
                }else{
                    // clearInterval(this.timeObj);
                    this.$message.error(res.message);
                }
            });
        },
        
         //余额支付
        balancePayment:function(){
            this.loading3 = true;
            clearInterval(this.timeObj);
            if(this.activityid >= this.total_money ){
                this.$post(this.$api.balancePayment, {
                    "rows":[{
                        id:this.$route.params.info,
                        gainpromoId:0,
                        balance:this.total_money,
                        discountMoney:0,
                    }],type:'PC'
                }).then(res=>{
                    this.loading3 = false;
                    if(res.code == 200){  
                        this.$message.success(res.data);
                        clearInterval(this.intvalobj);
                        this.$router.push('/user/order/'); 
                    }else{
                        this.loading3 = false;
                        this.$message.error(res.message);
                    }
                });
            }else{
                this.$message.error('全余额支付，余额不能小于订单金额！');
            }

        },
        //转账汇款
        // submitPayPwd:function(){
        //     this.BankAccountList = false;
        //     this.$post(this.$api.getBankAccount,{"rows":[{id:this.$route.params.info,gainpromoId:this.gainpromId,balance:this.balance.usemoney}]}).then(res=>{
        //         if(res.code == 200){
        //            return this.$router.push('/order/pay_success'); 
        //         }else{
        //             // this.money_pay = false;
        //              this.$message.error(res.message);
        //         }
        //     });
        // },
        //选择优惠券
        set_selectcoupon:function(ids){
                if(ids != this.active){
                    this.active = ids;
                    this.$put(this.$api.selectCouponsByGainPromoId,{id:this.$route.params.info,gainpromId:ids,platId:this.$platId}).then(res=>{
                        if(res.code == 200){
                            this.coupon_money = res.data.coupon_money;
                            this.gainpromId = res.data.gainpromId;
                            this.error = res.data.error;
                            //使用优惠券后芸欣币和芸欣币误差为0
                            this.discountMoney = res.data.discountMoney;
                            this.discountMrror = '0';
                            setTimeout(()=>{
                                this.get_list();
                            },500);
                            
                        }else{
                            return this.$message.error(res.message);
                        }
                    });
                }else{
                    this.active = -1;
                    this.coupon_money = '0';
                    this.gainpromId = '0';
                    this.error = '0';
                    this.$put(this.$api.selectCouponsByGainPromoId,{id:this.$route.params.info,gainpromId:'',platId:this.$platId}).then(res=>{
                        if(res.code == 200){
                            this.coupon_money = res.data.coupon_money;
                            this.gainpromId = res.data.gainpromId;
                            this.error = res.data.error;
                            // this.coupon_money = 0;
                            // this.error = 0;
                            //使用优惠券后芸欣币和芸欣币误差为0
                            this.discountMoney = '0';
                            this.discountMrror = '0';
                            setTimeout(()=>{
                                this.get_list();
                            },500);
                        }else{
                            return this.$message.error(res.message);
                        }
                    });
                    // this.getCalcVirtualMoney();
                }
        },

        //获取优惠券第一条
        getFirstCouponId:function(){
            // console.log(this.total_price);
            this.$get(this.$api.getCouponsToOrders+(this.total_price),{platId:this.$platId}).then(res=>{
                if(res.data.length != 0){
                    this.active = res.data[0].id;
                    this.$put(this.$api.selectCouponsByGainPromoId,{id:this.$route.params.info,gainpromId:this.active,platId:this.$platId}).then(res=>{
                        if(res.code == 200){
                            this.coupon_money = res.data.coupon_money;
                            this.gainpromId = res.data.gainpromId;
                            this.error = res.data.error;
                            //使用优惠券后芸欣币和芸欣币误差为0
                            this.discountMoney = '0';
                            this.discountMrror = '0';
                            this.get_list();
                        }else{
                            return this.$message.error(res.message);
                        }
                    });
                }else{
                  this.getCalcVirtualMoney(); 
                  this.get_list();
                }

            });
        },    


        //转账汇款
        set_default:function(){
            // if((this.total_money - this.balance.usemoney).toFixed(2) <= 0){
            //    return this.$message.error('支付金额为0，请使用余额支付!');
            // }
            this.BankAccountList = false;
            clearInterval(this.timeObj);
            // clearInterval(this.intvalobj);
            this.$confirm('是否确认转账?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                if((this.total_money - this.balance.usemoney).toFixed(2) > 0){
            this.$post(this.$api.transferAccounts,{"rows":[{id:this.$route.params.info,gainpromoId:0,balance:this.balance.usemoney,discountMoney:0,platId:this.$platId}],type:'PC'}).then(res=>{
                if(res.code == 200){
                     clearInterval(this.intvalobj);
                     this.payLogId = res.data;
                     this.$message.success(res.message);
                     this.change_transferShow = true;
                     this.payState = 2;
                     this.startTime = false;
                    //  this.$router.push('/user/order');
                }else{
                    return this.$message.error(res.message);
                }
            });
                }else{
                    this.$message.error('付款金额不能小于0');
                }
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '取消选择'
            });
            });
        },


        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 1;
            var isIMG = true;
            if (!isJPG) {
                if (!isPNG) {
                this.$message.error('上传图片只能是 JPG, PNG 格式!');
                isIMG = false;
                }
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isIMG && isLt2M;

        },
        handleAvatarSuccess(res) {
            this.payImg = this.filePath + res.data;
            // this.$forceUpdate();
        },


      //保存转账凭证
      paymentVoucher:function(){
          this.$post(this.$api.paymentVoucher,{payLogId:this.payLogId,payImg:this.payImg}).then(res=>{
              if(res.code==200){
                  this.$message.success(res.message);
                  this.change_transferShow = false;
                  clearInterval(this.timeObj);
                  this.$router.push('/user/order');
              }else{
                  clearInterval(this.timeObj);
                  this.$message.error(res.message);
              }

          });
      },
      cancel_transferShow:function(){
        this.change_transferShow = false;
        this.$message.success('请上传转账凭证!');
        this.$router.push('/user/order');
      },


        //添加银行账户
        // handleAddBankAccount() {
        //     this.dialogVisibleBankAccount = true;
        //     this.isEdit = false;
        //     this.info = Object.assign({},defaultInfo);
        // },
        submitForm:function(e){
            let _this = this;
            // 验证表单
            this.$refs[e].validate(function(res){
                
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.createBankAccount;
                    if(_this.edit_id>0){
                        url = _this.$api.updateBankAccount+_this.edit_id;     
                        // Http 请求
                        _this.$put(url,_this.info).then(function(res){
                            if(res.code == 200){
                                _this.$message.success("编辑成功");
                                _this.dialogVisibleBankAccount = false;
                                _this.BankAccount_list();
                            }else{
                                _this.$message.error("编辑失败");
                            }
                        });
                    }else {
                    url = _this.$api.createBankAccount; 
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("添加成功");
                            _this.dialogVisibleBankAccount = false;
                            _this.BankAccount_list();
                        }else{
                            _this.$message.error("添加失败");
                        }
                    });
                    }

                }
            });
        },

        //显示账户列表
        toshow:function () {
            // console.log((this.total_money - this.balance.usemoney).toFixed(2));
            if((this.total_money - this.balance.usemoney).toFixed(2) > 0){
                this.BankAccountList = true;
            }else{
                this.$message.error('转账金额不能小于0');
                this.reload();
            }
        },
        // get_user_info:function(){
        //     this.$get(this.$api.homeGetUserInfo,{platId:this.$platId}).then(res=>{
        //         if(res.code == 200){
        //             this.nowUserId = res.data.id;
        //             // this.getCalcVirtualMoney(res.data.id);
        //         }
        //     });
        // },

        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.isLogin = true;
                    this.userInfo = res.data;
                    this.userInfo.isLogin = true;
                    this.nowUserId = res.data.id;
                    this.userInfo.nowTime =  Date.parse(new Date()) / 1000;
                    localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
                    //折扣率
                    if(res.data.company && res.data.rate){
                        if(res.data.rate != '-1'){
                            localStorage.setItem('discount_rate',res.data.rate);
                        }else{
                            localStorage.setItem('discount_rate','');
                        }
                    }else{
                        this.getDiscountRate();
                    }
                }else if(res.code == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');        //用户信息
                    localStorage.removeItem('goodsCategory');   //栏目分类
                    localStorage.removeItem('column_list');     //底部菜单
                    localStorage.removeItem('popup_num');       //弹窗广告
                    localStorage.removeItem('serviceInfo');     //清除专属客服专属业务员
                    localStorage.removeItem('token');           //清除token
                    localStorage.removeItem('discount_rate');   //清除折扣率
                    this.isLogin = false;
                }else{
                    this.isLogin = false;
                }

            });
        },

         //获取折扣率
        getDiscountRate:function(){
            this.$get(this.$api.getDiscountRate,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    if(res.data && res.data.length > 0){
                        this.discount_rate = res.data[0].rate;
                        localStorage.setItem('discount_rate',JSON.stringify(res.data[0].rate));
                                            }
                }

            });
        },

        //显示优惠券
        isCoupon:function(){
            this.showGainprom = false;
            this.showCoupon = true;
            this.discountMoney = 0;
            this.discountMrror = 0;
            this.isSelect = 1;
            this.getFirstCouponId();
            setTimeout(()=>{
                this.get_list();
            },500);
        },
        //显示欣币
        isGainprom:function(){
            this.showGainprom = true;
            this.showCoupon = false;
            this.getCalcVirtualMoney();
            setTimeout(()=>{
                this.get_list();
            },500);
            this.isSelect = 2;
            this.coupon_money = 0;
            this.gainpromId = null;
            this.error = 0;
        },

        //收货地址列表
        get_address_list:function(){
            this.$get(this.$api.getAddressList).then(res=>{
                // this.address_list = res.data;
                // 如果没有设置默认地址则设置一个
                if(res.data.length>0){
                    let a = 4;
                    res.data.forEach(addressRes=>{
                        if(addressRes.status == 3){
                            this.addressId = addressRes.id;
                            this.defaultAddress = addressRes;
                            this.address_list.push(addressRes);
                            a += 1;
                        }
                    });
                    if(a==4){
                        this.set_defaultAddress(this.address_list[0].id);
                    }
                }
            });
        },
        
        //设置默认收货地址
        set_defaultAddress:function(id){
            this.addressId = id;
            this.selectAddress(id); //获取默认收货地址
            this.$put(this.$api.setDefaultAddress,[{id:id,status:3}]).then(()=>{
                this.get_address_list();
                // return this.$message.success('修改默认地址成功');
            });
        },

        //商品详情
        handleViewsGoods:function(index,row){
            let goodsUrl = this.$router.resolve({ path: '/goods/info/' + row.goodsId});
            window.open(goodsUrl.href, '_blank');
        },

        //修改收货地址
        selectAddress:function(info){
            this.$post(this.$api.updateOrderInfo,
                {
                orderId:this.$route.params.info,
                express:'',
                addressId:info,
                remark:''
                }
                ).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.message);
                        this.activeNames = ['4'], //保存成功收起面板
                        this.get_list();
                    }else{
                        this.$message.error(res.message);
                    }
            });
        },

        //修改配送方式
        selectExpress:function(express){
            this.$post(this.$api.updateOrderInfo,{
                orderId:this.$route.params.info,
                express:express,
                addressId:'',
                remark:''
            }).then(res=>{
                if(res.code == 200){
                    this.$message.success(res.message);
                    this.balance.usemoney = 0;
                    this.activeNames = ['4'], //保存成功收起面板
                    this.get_list();
                }else{
                    this.$message.error(res.message);
                }

            });
        },
        //修改备注
        selectRemark:function(remark){
            this.$post(this.$api.updateOrderInfo,
                {
                orderId:this.$route.params.info,
                express:this.express,
                addressId:'',
                remark:remark
                }
                ).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.message);
                        this.activeNames = ['4'], //保存成功收起面板
                        this.get_list();
                    }else{
                        this.$message.error(res.message);
                    }
            });
        },
        //获取银行账户及开户行
        getquerySconfigBankInfo:function(){
            this.$get(this.$api.bankInfo,{platId:this.$platId}).then(res=>{
                this.bankInfo = res.data[0];
            })
        },

        //支付方式列表
        getPayMentList:function(){
            this.$get(this.$api.getPaymentType,{
                platId:this.$platId,
                terminal:'1'
            }).then(res=>{
                this.payInfo = res.data;
                console.log(this.payInfo);
            })
        },
        //获取支付方式ID后支付
        payWayInfo:function(e){
            // alert(e.id);
        }

    },
    created() {
        // this.balance.usemoney = 0;
        if(localStorage.getItem('filePath')){
            this.filePath = localStorage.getItem('filePath');
        }else{
            this.filepath();
        }
        // this.getPayMentList();
        this.getquerySconfigBankInfo();
        this.get_user_info();
        // this.getCalcVirtualMoney();
        this.orderId = this.$route.params.info;
        this.get_order_list();
        this.BankAccount_list();
        
        // this.filepath();
        this.get_address_list();
        //团购不可用优惠券
        if(this.$route.query.c != undefined){
            this.groupBuy = false
        }
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
        
    },
    mounted() {
        // document.querySelector('body').setAttribute('style', 'background-color:#E9EAEE');
        // this.useqrcode();
        // if(this.dialogVisible = false){
        //     this.pay();
        //     this.timer = setInterval(() => {
        //         setTimeout(this.pay, 0)
        //     }, 1000*60)
        // }
            // this.timer = setInterval(() => {
            //     setTimeout(this.pay, 0)
            // }, 1000*60)
    },
    beforeDestroy() {
        //document.querySelector('body').removeAttribute('style');
        // clearInterval(this.timer);        
        // this.timer = null;
    },
};
</script>
<style lang="scss" scoped>
.scan_qr{
    text-align: center;
}
.empty_address{
    margin-bottom: 80px;
    line-height: 102px;
    border:3px solid #efefef;
    border-radius: 3px;
    text-align: center;
    width: 285px;
    height: 102px;
    span{
        color:#38A93C;
    }
    a:hover{
        color:#38A93C;
    }
}
.join_bzt{
    margin-top:40px;
}
.foot_create_order{
    margin-top: 50px;
    float: right;
    margin-right: 30px;
    .total_price{
        font-size: 28px;
        color:#38A93C;
        line-height: 28px;
        span{
            float: left;
            font-size: 14px;
            color:#333;
            
        }
        font{
            float: right;
            font-size: 14px;
            color:#666;
            margin-left: 20px;
        }
    }
    .foot_create_order_btn{
        float:right;
        margin-top: 20px;
        margin-bottom: 40px;
    }
}
.store_list{
    .store_info{
        margin-top: 20px;
        margin-left: 15px;
        
        dl dt{
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: #f1f1f1;
            float: left;
            margin-right: 15px;
        }
        dl dd{
            float: left;
            line-height: 30px;
        }
    }
    ul li{
        border-bottom: 1px solid #efefef;
        padding-bottom: 20px;
        margin-bottom: 20px;
        .x_price{
            color:#38A93C;
        }
        text-indent: 20px;
    }
    ul li .goods_info{
        text-indent: 0px;
    }
    ul li:last-child{
        border-bottom: none;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
    .order_list{
        margin-top: 20px;
        color:#666;
        font-size: 12px;
        border:1px solid #efefef;
        padding:20px;
        line-height: 40px;
        .goods_info{
            dl dt{
                width: 40px;
                height: 40px;
                background: #f8f8f8;
                float: left;
                margin-right: 15px;
            }
            dl dd{
                line-height: 20px;
            }
        }
    }
}
.order_list_title{
    color:#666;
    background: #f2f2f2;
    line-height: 40px;
    text-indent: 20px;
}
.order_chose .pay_list ul li:last-child{
    margin-right: 0px;
}
.order_chose{
    margin-top: 75px;
    margin-bottom: 75px;
    font-size: 14px;
    .pay_list{
        margin-bottom: 30px;
        ul:after{
            content:'';
            display: block;
            clear:both;
        }
        ul li{
            float: left;
            // width: 228px;
            // height: 82px;
            border-radius: 3px;
            border:1px solid #efefef;
            margin-right: 12px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            cursor: pointer;
        }
        ul li:nth-child(5){
            float: left;
            width: 228px;
            height: 82px;
            border-radius: 3px;
            border:1px solid #efefef;
            margin-right: 0px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            cursor: pointer;
        }
        ul li:hover{
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
    }

    .order_chose_title{
        font-size: 16px;
        clear: both;
        font-weight: bold;
        padding-bottom: 20px;
        margin-top: 30px;
    }
    .order_chose_title span{
        margin: 0 10px;
        cursor: pointer;
    }
    .order_chose_title span.default{
        font-weight: normal;
        font-size: 14px;
        color: #38A93C;
    }
    
}

.bank_chose{
    margin-top: 25px;
    font-size: 14px;
    text-align: right;
    .bank_chose_title{
        font-size: 16px;
        clear: both;
        font-weight: bold;
        padding-bottom: 20px;
    }
    .bank_list{
        ul:after{
            content:'';
            display: block;
            clear:both;
        }
        margin-bottom:30px; 
        ul li{
            float: right;
            text-align: left;
            box-sizing: border-box;
            width: 300px;
            height: 102px;
            border-radius: 3px;
            border:2px solid #efefef;
            margin-right: 10px;
            margin-bottom: 10px;
            padding:20px;
            position: relative;
            cursor: pointer;
            .receive_name{
                margin-bottom: 10px;
                font-weight: bold;
                line-height: 18px;
                span{
                    font-weight: normal;
                    color:#666;
                    font-size: 12px;
                }
            }
            .area_info{
                color:#666;
            }
            .is_default{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -11px;
                bottom: -8px;
            }
            .is_default_red{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -11px;
                bottom: -8px;
                color:#38A93C;
            }
        }
        ul li.red{
            border-color: #38A93C;
        }
        ul li:nth-child(4n){
            margin-right: 0;
        }
    }
}
em{font-style: normal;}
.coupon-enable {
    display: block;
    width: 1200px;
}
.coupon-main  li {
    width: 185px;
    height: 125px;
    float: left;
    margin: 9px;
}
.coupon-main  li:nth-child(7n),.coupon-main  li:first-child{
    margin-left: 0px;
}
.coupon-main  li:nth-child(6n){
    margin-right: 0px;
}
.coupon-main  .coupon-item.coupon-item-new {
    height: 125px;
}
.coupon-main  .coupon-item {
    // height: 105px;
    // width: 180px;
    // float: left;
    // margin-right: 9px;
    // margin-left: 9px;
    // margin-bottom: 18px;
    padding: 1px;
    position: relative;
}
.coupon-main  .coupon-item .item-selected {
    border: 2px solid #e43a3d;
    background-image: url(/pc/coupon-selected.png);
    background-repeat: no-repeat;
    background-position: bottom right;
}
.coupon-main  .coupon-item .item-selected .c-dong {
    border-left: 0;
    border-right: 0;
}
.coupon-main  .coupon-item .c-detail .c-dong {
    border-left: 1px solid #38A93C;
    border-right: 1px solid #38A93C;
    background-color: #38A93C;
}
.coupon-main  .coupon-item .c-detail .c-msg {
    cursor: pointer;
    height: 70px;
    width: 177px;
    position: relative;
}
.coupon-main  .coupon-item .item-selected .c-dong .c-top-dong {
    height: 0;
}
.coupon-main  .coupon-item .c-detail .c-top-dong {
    height: 3px;
    width: 100%;
    background: #fff url(/pc/virtual-spite.png) -40px -6px no-repeat;
}
.coupon-main  .coupon-item .c-detail .c-msg .c-price {
    color: #fff;
    font: 24px Arial,Verdana,'Microsoft YaHei',SimSun;
    display: inline;
    position: relative;
    top: 8px;
    margin-left: 12px;
    vertical-align: bottom;
    *float: left;
}
.coupon-main  .coupon-item .c-detail .c-msg .c-limit, .coupon-main  .coupon-item .c-detail .c-msg .c-over {
    color: #f5f5f5;
    font-size: 12px;
    display: inline;
    position: relative;
    top: 7px;
}
.coupon-main  .coupon-item .c-detail .c-msg .c-limit, .coupon-main  .coupon-item .c-detail .c-msg .c-over {
    color: #f5f5f5;
    font-size: 12px;
    display: inline;
    position: relative;
    top: 7px;
}
.coupon-main  .coupon-item .c-detail .c-msg .c-time-dong {
    color: #38A93C;
}
.coupon-main  .coupon-item .c-detail .c-msg .c-time {
    padding-left: 12px;
    margin-top: 10px;
    *clear: both;
}
.coupon-main  .coupon-item .c-detail .c-msg .c-time-dong span {
    float: left;
    color: #fff;
}
.coupon-main  .coupon-item .item-selected .c-type-dong {
    border: none !important;
}
.item-selected .c-detail .c-type-dong {
    color: #38A93C;
	border: none;
}
.coupon-main  .coupon-item .c-detail .c-type-dong {
    color: #38A93C;
	border: 1px solid #38A93C;
}

.coupon-main  .coupon-item .c-detail .c-type {
    height: 25px;
    width: 177px;
    padding-top: 5px;
}
.coupon-main  .coupon-item .c-detail .c-type span.c-type-l {
    margin: 0 5px 0 12px;
}
.coupon-main  .coupon-item .c-detail .c-type span.c-type-r {
    margin: 0;
    cursor: pointer;
}
.coupon-main  .coupon-item .c-info {
    height: 40px;
    width: 210px;
    color: #333;
}

.order-summary .statistic {
    width: 350px;
    margin-bottom: 10px;
    margin-right: 20px;
}
.fr {
    float: right;
}
.mt20 {
    margin-top: 20px;
}
.order-summary .statistic .list {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin-bottom: 5px;
    zoom: 1;
}
.order-summary .statistic span {
    width: 180px;
    margin-right: 20px;
    float: left;
    text-align: right;
}
.order-summary .statistic em {
    color: #e4393c;
}
.order-summary .statistic .price {
    color: #333;
    float: left;
    width: 100px;
    text-align: right;
    font-family: verdana;
}
.clear, .clr {
    display: block;
    overflow: hidden;
    clear: both;
    height: 0;
    line-height: 0;
    font-size: 0;
}
.trade-foot-detail-com {
    padding: 15px 10px 15px 0;
    line-height: 20px;
    text-align: right;
    border-top: 1px solid #e6e6e6;
    color: #999;
    background-color: #f4f4f4;
}
.trade-foot-detail-com .fc-price-info{
    margin-right: 10px;
    line-height: 25px;
}
.trade-foot-detail-com .fc-price-info .price-tit {
    color: #666;
}
.trade-foot-detail-com .fc-price-info .price-num{
    color: #e4393c;
    font-family: Verdana;
    font-weight: 700;
    font-size: 18px;
    min-width: 122px;
    _width: 122px;
    float: right;
    *float: none;
    text-align: right;
}
input{
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
.mr20{
    margin-right: 20px;
}
.time{
    float:left;
    width: auto;
    height: 80px;
    background: #38A93C;
    font-size: 40px;
    color: #fff;
    line-height: 80px;
    text-align: center;
    font-weight: bold;
    border-radius: 5px;
    margin-left: 10px;
    padding-left:20px;
    padding-right:20px;
}
.time span{
    float: right;;
    width: auto;
    height: 20px;
    font-size: 13px;
    color: #fff;
    line-height: 20px;
    text-align: center;
    font-weight: bold;
    margin-top: 40px;
    margin-bottom: 20px;
    margin-left: 10px;
}
</style>

<style>
  .table-layout {
    margin-top: 20px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
  }

  .table-cell {
    height: 48px;
    line-height: 48px;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    font-size: 14px;
    color: #606266;
    text-align: center;
    overflow: hidden;
  }
  .table-cell p{
    line-height: 35px;
  }
  .table-cell-title {
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    height: 48px;
    line-height: 48px;
    background: #f5f7fa;
    text-align: center;
    font-size: 14px;
    color: #909399;
  }
  .color-danger{
      color: #e4393c;
      font-size: 20px;
  }
  .color-mony{
      color: #e4393c;
  }
  .info-mony{
      color: #909399;
  }
  
</style>

<style lang="scss"  scoped>
.title-selected{
    color: #38A93C;
}
.address_chose{
    margin-top: 25px;
    font-size: 14px;
    .address_chose_title{
        font-size: 16px;
        clear: both;
        font-weight: bold;
        padding-bottom: 20px;
    }
    .address_list{
        ul:after{
            content:'';
            display: block;
            clear:both;
        }
        margin-bottom:30px; 
        ul li{
            float: left;
            box-sizing: border-box;
            width: 292px;
            height: 105px;
            border-radius: 3px;
            border:2px solid #efefef;
            margin-right: 10px;
            margin-bottom: 10px;
            padding:20px;
            position: relative;
            cursor: pointer;
            .receive_name{
                margin-bottom: 10px;
                font-weight: bold;
                line-height: 18px;
                span{
                    font-weight: normal;
                    color:#666;
                    font-size: 12px;
                }
            }
            .area_info{
                color:#666;
            }
            .is_default{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -10px;
                bottom: -12px;
            }
            .is_default_red{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -10px;
                bottom: -12px;
                color:#38A93C;
            }
        }
        ul li.red{
            border-color: #38A93C;
        }
        ul li:nth-child(4n){
            margin-right: 0;
        }
    }
}
.is-active .order_chose_title{
    color: #303133;
}

</style>

<style>
.el-collapse-item__arrow.is-active{
    color: #38A93C;
    cursor: pointer;
    font-weight: bold;
}
.el-table th.is-leaf{
    background: #f5f7fa;
}
.el-table th.is-leaf .cell{
    font-size: 15px;
    font-weight: bold;
}
.payIco{
    float: left;
    width: 84px;
    text-align: center;
}
.payIco i{
    font-size: 40px;
    line-height: 84px;
}
.payText{
    font-size: 24px;
    width: 140px;
    float: right;
    text-align: left;
    line-height: 84px;
}
</style>